// Import: Middleware Action & Custom Types
import { NIRS_CLEAN, NIRS_CLEAN_ERROR } from "_models/redux/types";

// Action function
export const cleanNirs = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        dispatch({
            type: NIRS_CLEAN,
            payload: [],
        });
    } catch (e) {
        dispatch({
            type: NIRS_CLEAN_ERROR,
            payload: {},
        });
    }
};
